<script>
export default {
  name: 'ConversationPinnedMessage',
  props: {
    pinnedMessage: {
      type: Object,
      default: null,
    },
  },
  emits: ['unpin', 'scroll-to'],
  computed: {
    previewText() {
      if (!this.pinnedMessage?.content) return '';
      const text = this.pinnedMessage.content.replace(/\n/g, ' ');
      return text.length > 80 ? text.slice(0, 80) + '…' : text;
    },
  },
};
</script>

<template>
  <div
    v-if="pinnedMessage"
    class="aceleres-pinned-banner flex items-center gap-2 px-3 py-2 bg-n-brand/5 border-b border-n-brand/20 cursor-pointer hover:bg-n-brand/10 transition-colors"
    @click.stop="$emit('scroll-to', pinnedMessage.id)"
  >
    <span class="i-lucide-pin w-3.5 h-3.5 text-n-brand flex-shrink-0" />
    <div class="flex-1 min-w-0">
      <p class="text-xs font-medium text-n-brand mb-0">Mensagem fixada</p>
      <p class="text-xs text-n-slate-11 truncate mb-0">{{ previewText }}</p>
    </div>
    <button
      type="button"
      class="flex-shrink-0 w-5 h-5 flex items-center justify-center rounded hover:bg-n-alpha-2 text-n-slate-9 hover:text-n-slate-12 transition-colors"
      @click.stop="$emit('unpin')"
    >
      <span class="i-lucide-x w-3 h-3" />
    </button>
  </div>
</template>
